/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Poll',
    slug: 'Poll',
    icon: 'GridIcon'
  },
  {
    url: '/question',
    name: 'Question',
    slug: 'Question',
    icon: 'GridIcon'
  },
  {
    url: '/spinRandom',
    name: 'SpinRandom',
    slug: 'SpinRandom',
    icon: 'GridIcon'
  },
  {
    url: '/report',
    name: 'Report',
    slug: 'page2',
    icon: 'FileIcon'
  }
]
